{
  "$id": "wealthlane://forms/tax-period/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "tax_period_name",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/name",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 300,
          "maxWidthPx": 600
        }
      ]
    },
    {
      "rowId": "tax_period_dates",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/effectiveFrom",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        },
        {
          "scope": "#/properties/effectiveTill",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 320
        }
      ]
    }
  ]
}
